/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svr_GenerateInputs */

const en_svr_generate = /** @type {(inputs: Svr_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generate SVR`)
};

const ja_svr_generate = /** @type {(inputs: Svr_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SVR を作成`)
};

const fr_svr_generate = /** @type {(inputs: Svr_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Générer SVR`)
};

const de_svr_generate = /** @type {(inputs: Svr_GenerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SVR erstellen`)
};

/**
* | output |
* | --- |
* | "Generate SVR" |
*
* @param {Svr_GenerateInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const svr_generate = /** @type {((inputs?: Svr_GenerateInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svr_GenerateInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_svr_generate(inputs)
	if (locale === "ja") return ja_svr_generate(inputs)
	if (locale === "fr") return fr_svr_generate(inputs)
	return de_svr_generate(inputs)
});